import React, { useEffect } from 'react'
import AdminHeader from '../../components/adminComponents/adminHeaderSidebarTitleComponents/AdminHeader'
import AdminSidebar from '../../components/adminComponents/adminHeaderSidebarTitleComponents/AdminSidebar'
import DriverRideComponent from '../../components/driverComponents/driverRouteComponents/DriverRideComponent';
import { useSelector } from 'react-redux'
import { navigateUserFunc } from '../../actions/generalActions'
import { useNavigate } from 'react-router-dom';
import NotAllowed from '../../components/NotAllowed';

const DriverRouteStartRide = () => {
    let navigate = useNavigate();
    const auth = useSelector((state) => state?.auth);
    useEffect(() => {
        if (auth?.user?.permissionId?.myRoutes?.isAllow === false){
            navigateUserFunc(auth?.user, navigate)
        }
    },[])
    return (
        <>
            <AdminHeader />
            <AdminSidebar />
            <div className="body-wrapper clearfix">
                <section className="main-container " id="fullscreen">
                    <div className="px-4 py-2 border-top-0 emp-dashboard">
                        <div className="d-lg-flex d-md-flex d-block py-4">
                            <div>
                                <h4 className=" mb-0 f-21 text-capitalize font-weight-bold">
                                    Manage Ride
                                </h4>
                            </div>
                        </div>
                        {
                            auth?.user?.permissionId?.myRoutes?.create === true ?
                            <DriverRideComponent />
                            :
                            <NotAllowed />
                        }
                        {/* <NavigationTab /> */}
                    </div>
                </section>
            </div>
        </>
    )
}
export default DriverRouteStartRide